export default "__VITE_ASSET__Ch7cRo0K__"